import { useContext } from 'react'

import {
  Box,
  Button,
  EntityMultiSelect,
  Form,
  ModalContext,
  SidebarModal,
  Text,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useManageBrandImageSettingsPermissionsModal from './hooks/useManageBrandImageSettingsPermissionsModal'

const MODAL_KEY = 'ManageBrandImageSettingsPermissionsModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const ManageBrandImageSettingsPermissionsModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { brand: initBrand } = modalPayload

  const manageBrandImageSettingsPermissionsModalPayload = useManageBrandImageSettingsPermissionsModal({ brand: initBrand })
  const {
    agencies,
    brand,
    callbacks: {
      loadMoreAgencies,
      setSelectedEntityIds,
      setState,
      updateBrandImageSettings,
      updateBrandFn,
    },
    canLoadMore,
    filteredAgenciesCount,
    filteredAgencyIds,
    loadingAgencies,
    string,
    selectedEntityIds,
    updatingBrand,
  } = manageBrandImageSettingsPermissionsModalPayload

  const updateBrandPayload = {
    callbacks: {
      action: updateBrandFn,
      afterAction: closeModal,
    },
    toastText: 'Agencies Updated',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Manage" titleSecondLine="Permissions" />

      <SidebarModal.SubHeader boxProps={{ padding: 'large' }}>
        <Box flexDirection="column">
          <Text color="bodyFontLightColor" fontSize="small">Managing Agencies For</Text>

          <Text marginTop="medium">{brand.title}</Text>
        </Box>
      </SidebarModal.SubHeader>

      <SidebarModal.Content hasSubHeader>
        <Form>
          <Form.Field label="Filter by Agency Title" marginTop="none">
            <input
              onChange={event => setState({ string: event.target.value })}
              type="text"
              value={string}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2741 */}
          <EntityMultiSelect
            boxProps={{ marginTop: 'medium' }}
            callbacks={{
              loadMore: loadMoreAgencies,
              setSelectedIds: setSelectedEntityIds,
            }}
            canLoadMore={canLoadMore}
            entities={agencies}
            entityCount={filteredAgenciesCount}
            filteredEntityIds={filteredAgencyIds}
            height={500}
            loading={loadingAgencies}
            selectedIds={selectedEntityIds}
          />
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!brand}
          loading={updatingBrand}
          onClick={() => updateBrandImageSettings(updateBrandPayload)}
          size="large"
        >
          Save Agencies
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <ManageBrandImageSettingsPermissionsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
